import React from 'react';
import PropTypes from 'prop-types';
import upperFirst from 'lodash/upperFirst';

import { TextField, MenuItem } from '@metarouter-private/mr-mui';
import { getChildTypes } from '@ion/api/audit-logs/query';

import { ENTITY_LABELS } from 'app/audit-logs/entity-labels';

// MUI's Select treats an empty-string value as "no selection" and renders its
// zero-width-space placeholder instead of the matching MenuItem, so the parent
// scope needs a non-empty sentinel to display its own label.
const PARENT_SCOPE = 'parent';

export default function ChildTypeSelector({ recordRef, value, onChange }) {
  const childTypes = getChildTypes(recordRef.entity);

  if (childTypes.length === 0) {
    return null;
  }

  const options = [
    { value: PARENT_SCOPE, label: `This ${ENTITY_LABELS[recordRef.entity].singular}`, testId: 'Parent' },
    ...childTypes.map(({ type }) => ({
      value: type,
      label: `Related ${ENTITY_LABELS[type].plural}`,
      testId: upperFirst(type),
    })),
  ];

  const handleChange = event => {
    onChange(event.target.value === PARENT_SCOPE ? null : event.target.value);
  };

  return (
    <TextField
      select
      fullWidth
      label="Scope"
      data-test-id="auditLogChildTypeSelector"
      value={value ?? PARENT_SCOPE}
      onChange={handleChange}
    >
      {options.map(option => (
        <MenuItem
          key={option.value}
          value={option.value}
          data-test-id={`auditLogChildTypeSelectorOption${option.testId}`}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

ChildTypeSelector.propTypes = {
  recordRef: PropTypes.shape({ entity: PropTypes.string.isRequired }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
